import './BottomNav.css';const bottomNav = "_bottomNav_ahf8q_1";
const styles = {
  bottomNav,
  "bottomNav--hidden": "_bottomNav--hidden_ahf8q_72"
};
export {
  bottomNav,
  styles as default
};
